import { TFunction } from "i18next";
import GuestBreakdown from "@/model/GuestBreakdown";

/** Bookings made before the breakdown existed only have guestCount; they're shown as adults. */
function ofBooking(booking: {
  guests?: GuestBreakdown;
  guestCount?: number;
}): GuestBreakdown {
  return booking.guests ?? { adults: booking.guestCount ?? 1, children: 0, infants: 0 };
}

/** "2 adults, 1 child, 1 infant", leaving out empty categories. */
function describe(t: TFunction, guests: GuestBreakdown): string {
  return [
    guests.adults > 0 ? t("guests.adultCount", { count: guests.adults }) : "",
    guests.children > 0 ? t("guests.childCount", { count: guests.children }) : "",
    guests.infants > 0 ? t("guests.infantCount", { count: guests.infants }) : "",
  ]
    .filter(Boolean)
    .join(", ");
}

const guestsUtils = {
  ofBooking,
  describe,
};

export default guestsUtils;
